@if (isConfigLoaded) {
  <div>
    @if (!this.restService.isVirgin()) {
      <section class="topup-section container">
        <div class="row">
          <div class="small-12 columns">
            <h1 class="text-bold text-light-black">
            {{getMainTitle()}} </h1>
          </div>
        </div>
      </section>
    }
    <div>
      @switch (currentRechargeState) {
        @case (RECHARGE_STATE.AMOUNT) {
          <amount-section
            [formGroup]="amountFormGroup"
          (submitEvent)="onRechargeDataCollected($event)"></amount-section>
        }
        @case (RECHARGE_STATE.PAYMENT) {
          <payment-section
            [formGroup]="paymentFormGroup"
            [paymentAmount]="paymentRequest.amount"
          (submitEvent)="onPaymentDataCollected($event)"></payment-section>
        }
        @case (RECHARGE_STATE.BLIK) {
          <blik-section
          (submitEvent)="onBlikDataCollected($event)"></blik-section>
        }
      }
    </div>
  </div>
}

@if (!isConfigLoaded) {
  <div style="display: flex; align-items: center; justify-content: center">
    <img src="assets/images/loader.gif" alt="loader"/>
  </div>
}
